import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { Overline } from 'components/Typography';
import DefaultRow from './Row';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
    0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
  border-radius: 1.5rem;
`;

export const Header = styled.header`
  display: grid;
  grid-template-columns: 2rem 1.5fr 1.5fr 1fr 1fr 5.625rem 1fr 6.5rem;
  height: 3rem;
  padding: 1.375rem 1rem 0.3125rem 1rem;

  > *:nth-child(7) {
    justify-self: flex-end;
    margin-right: 0.75rem;
  }
`;

export const Row = styled(DefaultRow)``;

export const Caption = styled(Overline)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  letter-spacing: 0.1em;
  font-weight: 600;
`;
